<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path stroke="currentColor" d="M3.65 4.65H12.35V12C12.35 12.7456 11.7456 13.35 11 13.35H5C4.25442 13.35 3.65 12.7456 3.65 12V4.65Z"  stroke-width="1.3"></path>
    <path stroke="currentColor" d="M5.65 4.6625H10.35V4C10.35 3.25442 9.74558 2.65 9 2.65H7C6.25442 2.65 5.65 3.25442 5.65 4V4.6625Z" stroke-width="1.3"></path>
    <rect fill="currentColor" x="6" y="7" width="1.3" height="4"></rect>
    <rect fill="currentColor" x="8.70312" y="7" width="1.3" height="4"></rect>
    <rect fill="currentColor" x="2" y="4" width="12" height="1.3125"></rect>
  </svg>
</template>